import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import PageTracker from './components/common/PageTracker'

import ChonLop from './pages/ChonLop/ChonLop'
import DanhSachLop from './pages/DanhSachLop/DanhSachLop'
import DanhSachChuong from './pages/DanhSachChuong/DanhSachChuong'
import XemBaiHoc from './pages/XemBaiHoc/XemBaiHoc'
import TongHop from './pages/TongHop/TongHop'
import TracNghiem from './pages/TracNghiem/TracNghiem'
import ThiOnline from './pages/ThiOnline/ThiOnline'
import LamTracNghiem from './pages/LamTracNghiem/LamTracNghiem'
import OnlineExamInterface from './pages/TracNghiem/OnlineExamInterface'
import BaiHoc from './pages/BaiHoc/BaiHoc'
import NhaBacHoc from './pages/NhaBacHoc/NhaBacHoc'
import MoPhong from './pages/MoPhong/MoPhong'
import AIHoiDap from './pages/AIHoiDap/AIHoiDap'
import {
  LessonBuilderPage,
  MyLessonsPage,
  LessonViewerPage,
  MyCoursesPage,
  CourseBuilderPage,
  CourseViewerPage,
} from './features/lesson-builder'
import ErrorBoundary from './components/common/ErrorBoundary'
import Footer from './components/common/Footer'
import { AuthProvider } from './contexts/AuthContext'
import { VoiceProvider } from './contexts/VoiceContext'
import { ChevronRight } from 'lucide-react'
import InteractiveDemo from './components/demo/InteractiveDemo'
import OscillationLessonDemo from './components/demo/OscillationLessonDemo'
import TestBank from './pages/TestBank/TestBank'
import DatabaseTestPage from './pages/DatabaseTest'
import QuestionStatsTest from './pages/QuestionStatsTest'
import KaTeXTest from './pages/KaTeXTest'
import ImageTestPage from './pages/ImageTestPage'
import TestAuth from './pages/TestAuth'
import SimpleHome from './pages/SimpleHome'
import Home from './pages/Home'
import SimpleHomePage from './pages/SimpleHomePage'
import TrangChu from './pages/TrangChu/TrangChu'
import AuthTest from './pages/AuthTest'
import DebugAuth from './pages/DebugAuth'
import ImageDisplayTestPage from './pages/ImageDisplayTestPage'
import ImageDebugTestPage from './pages/ImageDebugTestPage'
import ImagePathTestPage from './pages/ImagePathTestPage'
import SimpleImageTestPage from './pages/SimpleImageTestPage'
import ScoringTestPage from './pages/ScoringTestPage'
import ShortAnswerTestPage from './pages/ShortAnswerTestPage'
import DatabaseStructureTestPage from './pages/DatabaseStructureTestPage'
import AnswerFieldTestPage from './pages/AnswerFieldTestPage'
import TrueFalseDataTestPage from './pages/TrueFalseDataTestPage'
import DSSchemaTestPage from './pages/DSSchemaTestPage'
import DSDirectTestPage from './pages/DSDirectTestPage'
import DSLoadTestPage from './pages/DSLoadTestPage'
import BankDataFieldsTestPage from './pages/BankDataFieldsTestPage'
import DSPathDebugTestPage from './pages/DSPathDebugTestPage'
import TestIndexPage from './pages/TestIndexPage'
import ProfilePage from './pages/ProfilePage'
import SettingsPage from './pages/SettingsPage'
import AdminPage from './pages/AdminPage'
import DatabaseAdminPage from './pages/DatabaseAdminPage'
import SQLiteDatabasePage from './pages/SQLiteDatabasePage'


import PhysicsEnglishPage from './pages/PhysicsEnglishPage'
import PhysicsEnglishIndexPage from './pages/PhysicsEnglishIndexPage'
import FlashcardPage from './pages/Flashcard/FlashcardPage'
import EmailServiceTest from './components/test/EmailServiceTest'
import { DanhSachDeKiemTra } from './pages/TaoDeKiemTra/DanhSachDeKiemTra'
import { TaoMatranDeKiemTra } from './pages/TaoDeKiemTra/TaoMatranDeKiemTra'
import DeTuDongPage from './pages/DeTuDong/DeTuDong'
import AutoCoringPage from './pages/AutoCoring/AutoCoringPage'

// ✅ Admin & Teacher Components
import Layout from './components/common/Layout/Layout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AdminLayout from './pages/Admin/AdminLayout'
import AdminDashboard from './pages/Admin/AdminDashboard'
import UserManagement from './pages/Admin/UserManagement'
import RoleManagement from './pages/Admin/RoleManagement'
import TeacherApproval from './pages/Admin/TeacherApproval'
import StatisticsExport from './pages/Admin/StatisticsExport'
import StatsDashboard from './pages/Admin/StatsDashboard'
import EmailMarketing from './pages/Admin/EmailMarketing'
import ManageResources from './pages/Admin/ManageResources'


import Settings from './pages/Admin/Settings'
import FlashcardCreator from './pages/Teacher/FlashcardCreator'
import TeacherStudentManager from './pages/Teacher/TeacherStudentManager'
import TestTeacherContent from './pages/Teacher/TestTeacherContent'
import RandomNamePicker from './pages/Teacher/RandomNamePicker'
import MagneticFieldAR from './pages/Teacher/MagneticFieldAR/MagneticFieldAR'
import TestDatabasePart4 from './pages/TestDatabasePart4'
import TestQuizUpload from './pages/Teacher/TestQuizUpload'
import TestContentUploadManager from './pages/Teacher/TestContentUploadManager'
import TestGeoGebra from './pages/TestGeoGebra/TestGeoGebra'
import AILab from './pages/AILab/AILab'

// ✅ Phase 1 Test Page
import TestPhase1 from './pages/TestPhase1'

// ✅ DoorQuest Game Test Page
import TestGame from './pages/TestGame'
import GameStats from './pages/GameStats'
import TestGameDatabase from './pages/TestGameDatabase'
import TestPhysicsSurvivalRunner from './pages/TestPhysicsSurvivalRunner'

// ✅ Phase 2: Learning History Pages
import LichSuHocTap from './pages/LichSuHocTap'
import TestLearningHistory from './pages/TestLearningHistory'
import TestStudyProgress from './pages/TestStudyProgress'

// ✅ Phase 3: Server Synchronization
import SyncStatus from './components/sync/SyncStatus'

import AdvancedAnalytics from './pages/AdvancedAnalytics'
import Statistics from './pages/Statistics/Statistics'
import GamificationTestPage from './pages/GamificationTestPage'

import PhysicsBackground from './components/ui/PhysicsBackground'
import IntroScreen from './components/common/IntroScreen'
import PWAStatus from './components/common/PWAStatus'
import MobileConsole from './components/common/MobileConsole'
import { useState, useEffect } from 'react'
import { englishContentService } from './services/english/englishContentService'
import TeacherSession from './components/interactive/TeacherSession'
import StudentClient from './components/interactive/StudentClient'

// Component đơn giản để test
const HomePage = () => (
  <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
      <h1 className="text-5xl font-bold text-gradient-brilliant mb-8">
        AI-PhysicsBook
      </h1>
      <p style={{ fontSize: '20px', color: '#4b5563', marginBottom: '48px' }}>
        Chia sẻ, Kết nối, Truyền đam mê
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px', marginBottom: '64px' }}>
        <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>📚</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Nội dung bài học</h3>
          <p style={{ color: '#6b7280' }}>Kiến thức vật lí từ cơ bản đến nâng cao</p>
        </div>

        <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>🧮</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Công thức tương tác</h3>
          <p style={{ color: '#6b7280' }}>Công thức toán học với KaTeX</p>
        </div>

        <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>🎯</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Trắc nghiệm thông minh</h3>
          <p style={{ color: '#6b7280' }}>Hệ thống quiz đa dạng</p>
        </div>
      </div>

      <div style={{ marginBottom: '64px' }}>
        <a
          href="/ds-direct-test"
          className="btn-primary inline-block px-8 py-4 text-lg rounded-lg no-underline"
        >
          🎯 Test Câu Hỏi Đúng Sai
        </a>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px', maxWidth: '1000px', margin: '0 auto' }}>
        <a
          href="/lop/10"
          className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 no-underline hover:scale-105"
        >
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>🍎</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Lớp 10</h3>
          <p style={{ color: '#6b7280' }}>Cơ học - Newton</p>
        </a>

        <a
          href="/lop/11"
          className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 no-underline hover:scale-105"
        >
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>⚡</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Lớp 11</h3>
          <p style={{ color: '#6b7280' }}>Dòng điện - Ampère</p>
        </a>

        <a
          href="/lop/12"
          className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 no-underline hover:scale-105"
        >
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>🌌</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Lớp 12</h3>
          <p style={{ color: '#6b7280' }}>Lượng tử - Einstein</p>
        </a>

        <a
          href="/physics-english"
          className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 no-underline hover:scale-105"
        >
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>🌍</div>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>English Physics</h3>
          <p style={{ color: '#6b7280' }}>Learn Physics in English</p>
        </a>
      </div>
    </div>
  </div>
)

const TestPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">🧪 Test Page</h1>
      <p className="text-xl text-gray-600 mb-8">React Router đang hoạt động!</p>
      <div className="space-y-4">
        <a
          href="/"
          className="btn-primary block px-6 py-3 rounded-lg"
        >
          → Về trang chủ
        </a>
        <a
          href="/lop/10"
          className="btn-soft block px-6 py-3 rounded-lg"
        >
          → Xem lớp 10
        </a>
      </div>
    </div>
  </div>
)

function App() {
  const [showIntro, setShowIntro] = useState(true)
  const [isAppReady, setIsAppReady] = useState(false)

  // Preload critical data during intro
  useEffect(() => {
    if (showIntro) {
      const preloadCriticalData = async () => {
        try {
          // Preload logo (already done in IntroScreen, but can add more here)
          const logoImg = new Image()
          logoImg.src = '/AI-PhysicsBook.png'

          // Preload English content
          englishContentService.initialize().catch(console.error);

          // Mark app as ready (data preloaded)
          setIsAppReady(true)
          console.log('✅ App data preloaded')
        } catch (error) {
          console.warn('⚠️ Preload warning:', error)
          setIsAppReady(true) // Continue even if preload fails
        }
      }

      preloadCriticalData()
    }
  }, [showIntro])

  // ✅ Lazy Video Caching - Run in idle time to not block UI/Login
  useEffect(() => {
    if (!showIntro && isAppReady) {
      // Wait for user interaction to settle, then cache videos in background
      const idleTimeout = setTimeout(() => {
        // Use requestIdleCallback if available, otherwise fallback to setTimeout
        const scheduleVideoCaching = () => {
          import('./services/video/VideoCacheService').then(({ videoCacheService }) => {
            console.log('🎬 Starting background video caching...');
            videoCacheService.prefetchAllVideos().catch(console.error);
          });
        };

        if ('requestIdleCallback' in window) {
          // Run when browser is idle (low priority)
          requestIdleCallback(scheduleVideoCaching, { timeout: 30000 });
        } else {
          // Fallback: delay significantly to avoid blocking
          setTimeout(scheduleVideoCaching, 15000);
        }
      }, 10000); // Wait 10s after app ready before even considering caching

      return () => clearTimeout(idleTimeout);
    }
  }, [showIntro, isAppReady])

  const handleIntroComplete = () => {
    setShowIntro(false)
  }

  // Show intro screen first
  if (showIntro) {
    return (
      <IntroScreen
        onComplete={handleIntroComplete}
        minDuration={1600} // ~1.6s: 1 lần quét rồi vào app, đỡ chờ
      />
    )
  }

  // Main app after intro
  return (
    <ErrorBoundary>
      <AuthProvider>
        <VoiceProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <PageTracker />
            <PhysicsBackground />

            <Routes>
              {/* Trang chủ */}
              <Route path="/" element={<TrangChu />} />

              {/* 📝 Lesson Builder — Soạn bài giảng & khoá học e-learning */}
              <Route path="/teacher/khoa-hoc" element={<MyCoursesPage />} />
              <Route path="/teacher/elearning" element={<MyLessonsPage />} />
              <Route path="/soan-bai" element={<LessonBuilderPage />} />
              <Route path="/soan-bai/:id" element={<LessonBuilderPage />} />
              <Route path="/bai-giang/:slug" element={<LessonViewerPage />} />
              <Route path="/khoa-hoc/sua/:id" element={<CourseBuilderPage />} />
              <Route path="/khoa-hoc/:slug" element={<CourseViewerPage />} />

              {/* 🤖 Auto Coring Feature */}
              <Route path="/auto-coring" element={<AutoCoringPage />} />

              {/* 🎮 Test Game - Chạy game độc lập */}
              <Route path="/test-game" element={<TestGame />} />

              {/* 🏃 Test Physics Survival Runner - Game chạy 3 làn đường */}
              <Route path="/test-physics-survival-runner" element={<TestPhysicsSurvivalRunner />} />

              {/* 📊 Game Stats - Thống kê và xếp hạng */}
              <Route path="/thong-ke-game" element={<GameStats />} />

              {/* 🧪 Test Game Database - Test lưu kết quả */}
              <Route path="/test-game-db" element={<TestGameDatabase />} />

              {/* Trang chủ cũ */}
              <Route path="/old-home" element={<HomePage />} />

              {/* Simple Home Page */}
              <Route path="/simple-home" element={<SimpleHomePage />} />

              {/* Test page */}
              <Route path="/test" element={<TestPage />} />

              {/* Test Authentication */}
              <Route path="/test-auth" element={<TestAuth />} />

              {/* Auth Test */}
              <Route path="/auth-test" element={<AuthTest />} />

              {/* Debug Auth */}
              <Route path="/debug-auth" element={<DebugAuth />} />

              {/* Test Bank Service */}
              <Route path="/test-bank" element={<TestBank />} />

              {/* Database Test */}
              <Route path="/database-test" element={<DatabaseTestPage />} />

              {/* ✅ Test Database Part 4 - Chỉ chạy trong Dev */}
              <Route path="/test-database-part4" element={<TestDatabasePart4 />} />

              {/* Question Stats Test */}
              <Route path="/question-stats-test" element={<QuestionStatsTest />} />

              {/* KaTeX Test */}
              <Route path="/katex-test" element={<KaTeXTest />} />

              {/* Image Test */}
              <Route path="/image-test" element={<ImageTestPage />} />

              {/* Image Debug Test */}
              <Route path="/image-debug-test" element={<ImageDebugTestPage />} />

              {/* Image Path Test */}
              <Route path="/image-path-test" element={<ImagePathTestPage />} />

              {/* DS Path Debug Test */}
              <Route path="/ds-path-debug-test" element={<DSPathDebugTestPage />} />

              {/* Đề kiểm tra tự động */}
              <Route path="/de-tu-dong" element={<DeTuDongPage />} />



              {/* Simple Image Test */}
              <Route path="/simple-image-test" element={<SimpleImageTestPage />} />

              {/* Scoring Test */}
              <Route path="/scoring-test" element={<ScoringTestPage />} />

              {/* Short Answer Test */}
              <Route path="/short-answer-test" element={<ShortAnswerTestPage />} />

              {/* Database Structure Test */}
              <Route path="/database-structure-test" element={<DatabaseStructureTestPage />} />

              {/* Answer Field Test */}
              <Route path="/answer-field-test" element={<AnswerFieldTestPage />} />

              {/* Image Display Test */}
              <Route path="/image-display-test" element={<ImageDisplayTestPage />} />

              {/* True False Data Test */}
              <Route path="/true-false-data-test" element={<TrueFalseDataTestPage />} />

              {/* DS Schema Test */}
              <Route path="/ds-schema-test" element={<DSSchemaTestPage />} />



              {/* DS Direct Test */}
              <Route path="/ds-direct-test" element={<DSDirectTestPage />} />

              {/* DS Load Test */}
              <Route path="/ds-load-test" element={<DSLoadTestPage />} />

              {/* Bank Data Fields Test */}
              <Route path="/bank-data-fields-test" element={<BankDataFieldsTestPage />} />

              {/* Test Index */}
              <Route path="/test-index" element={<TestIndexPage />} />

              {/* Email Service Test */}
              <Route path="/test-email" element={<EmailServiceTest />} />

              {/* ✅ Phase 1 Integration Test */}
              <Route path="/test-phase1" element={<TestPhase1 />} />

              {/* 🎮 Test GeoGebra Integration */}
              <Route path="/test-geogebra" element={<TestGeoGebra />} />

              {/* 🤖 AI Physics Lab */}
              <Route path="/ai-lab" element={<AILab />} />

              {/* ✅ Phase 2: Learning History */}
              <Route path="/test-learning-history" element={<TestLearningHistory />} />
              <Route path="/test-study-progress" element={<TestStudyProgress />} />
              <Route path="/lich-su-hoc-tap" element={<LichSuHocTap />} />
              <Route path="/history" element={<LichSuHocTap />} />

              {/* Profile and Settings */}
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/ho-so" element={<ProfilePage />} />
              <Route path="/thong-tin-ca-nhan" element={<ProfilePage />} />
              <Route path="/cai-dat" element={<SettingsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/database-admin" element={
                <ProtectedRoute requiredRole="admin">
                  <DatabaseAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/sqlite-database" element={
                <ProtectedRoute requiredRole="admin">
                  <SQLiteDatabasePage />
                </ProtectedRoute>
              } />


              {/* ✅ NEW: Admin Routes (Protected) */}
              <Route path="/admin/*" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }>
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="roles" element={<RoleManagement />} />
                <Route path="teachers" element={<TeacherApproval />} />
                <Route path="statistics" element={<StatisticsExport />} />
                <Route path="access-stats" element={<StatsDashboard />} />
                <Route path="access_stats" element={<StatsDashboard />} />
                <Route path="settings" element={<Settings />} />
                <Route path="email" element={<EmailMarketing />} />
                <Route path="database" element={<DatabaseAdminPage />} />
                <Route path="resources" element={<ManageResources />} />
              </Route>
              <Route path="/teacher/magnetic-ar" element={
                <ProtectedRoute requiredRole="teacher">
                  <MagneticFieldAR />
                </ProtectedRoute>
              } />

              {/* ✅ NEW: Teacher Routes (Protected) */}
              <Route path="/teacher/flashcards" element={
                <ProtectedRoute requiredRole="teacher">
                  <FlashcardCreator />
                </ProtectedRoute>
              } />
              <Route path="/teacher/students" element={
                <ProtectedRoute requiredRole="teacher">
                  <TeacherStudentManager />
                </ProtectedRoute>
              } />
              <Route path="/teacher/test-content" element={
                <ProtectedRoute requiredRole="teacher">
                  <TestTeacherContent />
                </ProtectedRoute>
              } />
              <Route path="/teacher/randomname" element={
                <ProtectedRoute requiredRole="teacher">
                  <RandomNamePicker />
                </ProtectedRoute>
              } />
              <Route path="/test-teacher-content" element={<TestTeacherContent />} />
              <Route path="/test-quiz-upload" element={<TestQuizUpload />} />
              <Route path="/test-content-upload" element={<TestContentUploadManager />} />

              {/* ✅ Interactive Classroom (ClassPoint-like) */}
              <Route path="/teacher/live" element={
                <ProtectedRoute requiredRole="teacher">
                  <TeacherSession />
                </ProtectedRoute>
              } />
              <Route path="/live" element={<StudentClient />} />
              <Route path="/live/:code" element={<StudentClient />} />

              {/* OLD Admin Pages (Deprecated) */}
              <Route path="/old-admin" element={<AdminPage />} />


              {/* Physics English */}
              <Route path="/physics-english" element={<PhysicsEnglishIndexPage />} />
              <Route path="/physics-english/:lop/:chuong/:bai" element={<PhysicsEnglishPage />} />

              {/* Flashcard from PDF - Chỉ giáo viên */}
              <Route path="/flashcard" element={
                <ProtectedRoute requiredRole="teacher">
                  <FlashcardPage />
                </ProtectedRoute>
              } />

              {/* Interactive Demo */}
              <Route path="/demo/interactive" element={
                <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <InteractiveDemo />
                  </div>
                </div>
              } />

              {/* Oscillation Lesson Demo */}
              <Route path="/demo/oscillation" element={
                <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <OscillationLessonDemo />
                  </div>
                </div>
              } />

              {/* Trang tổng hợp với filter */}
              <Route path="/tong-hop" element={<TongHop />} />

              {/* Redirect routes for menu items */}
              <Route path="/bai-hoc" element={<BaiHoc />} />
              <Route path="/trac-nghiem" element={<ThiOnline />} />
              <Route path="/on-tap" element={<TracNghiem />} />
              <Route path="/trac-nghiem/:lop/:chuong/:bai" element={<LamTracNghiem />} />
              <Route path="/exam/:slug" element={<OnlineExamInterface />} />
              <Route path="/mo-phong" element={<MoPhong />} />
              <Route path="/nha-bac-hoc" element={<NhaBacHoc />} />
              <Route path="/ai-hoi-dap" element={<AIHoiDap />} />

              {/* Tạo đề kiểm tra KTGKI, KTCKI, KTGKII, KTCKII */}
              <Route path="/tao-de-kiem-tra" element={<DanhSachDeKiemTra />} />
              <Route path="/tao-de-kiem-tra/tao-moi" element={<TaoMatranDeKiemTra />} />
              <Route path="/tao-de-kiem-tra/chinh-sua/:id" element={<TaoMatranDeKiemTra />} />

              {/* Danh sách lớp */}
              <Route path="/lop" element={<DanhSachLop />} />

              {/* Chọn lớp */}
              <Route path="/lop/:idLop" element={<ChonLop />} />

              {/* Danh sách chương */}
              <Route path="/lop/:idLop/chuong/:idChuong" element={<DanhSachChuong />} />

              {/* Xem bài học chi tiết */}
              <Route path="/lop/:idLop/chuong/:idChuong/bai/:idBai" element={<XemBaiHoc />} />

              {/* Fallback route */}
              <Route path="*" element={
                <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
                  <div className="text-center">
                    <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
                    <h2 className="text-2xl font-semibold text-gray-600 mb-4">Không tìm thấy trang</h2>
                    <p className="text-gray-500 mb-8">Trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.</p>
                    <a
                      href="/"
                      className="btn-primary inline-flex items-center px-6 py-3 font-medium rounded-lg"
                    >
                      ← Về trang chủ
                    </a>
                  </div>
                </div>
              } />
            </Routes>

            {/* Sync Status Widget */}
            <SyncStatus />

            {/* PWA Status & Update Manager */}
            <PWAStatus />

            {/* 🐞 Mobile Debug Console - Always visible for debugging */}
            <MobileConsole />
          </Router>
        </VoiceProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App

